import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-between gap-2 w-100" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Questions fréquentes")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("mot de passe oublié ?")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, _mergeProps(_ctx.formParams, { loadingKey: "login" }), {
    "custom-footer": _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_router_link, {
          class: "btn btn-link",
          to: { name: 'faqs.public' }
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode(_component_router_link, {
          class: "btn btn-link",
          to: { name: 'auth.request-reset-password' }
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ]),
    _: 1
  }, 16))
}